import styled from "styled-components";
import { useSelector } from "react-redux";

const Skill = ({ name, deg }) => {
	const color = useSelector((state) => state.colorSlice.value);
	return (
		<Progress color={color} deg={deg}>
			<div className="top">
				<p>{name}</p>
				<p>{deg}%</p>
			</div>
			<div className="bar">
				<div className="inner"></div>
			</div>
		</Progress>
	);
};

export default Skill;

const Progress = styled.div`
	width: 400px;
	@media screen and (max-width: 1110px) {
		width: 600px;
	}
	@media screen and (max-width: 768px) {
		width: 400px;
	}
	@media screen and (max-width: 530px) {
		width: 280px;
	}
	.top {
		display: flex;
		justify-content: space-between;
		align-items: center;
		p {
			font-size: 1.5rem;
			@media screen and (max-width: 500px) {
				font-size: 1.2rem;
			}
		}
	}
	.bar {
		width: 100%;
		height: 5px;
		background-color: #444;
		border-radius: 5px;
		margin-top: 1rem;
		.inner {
			background-color: ${(props) => props.color};
			border-radius: 5px;
			height: 100%;
			width: ${(props) => props.deg}%;
		}
	}
`;
